<script setup>
import { ref } from 'vue'
import Step from './Step.vue'
import Prize from './Prize.vue'
import Share from './Share.vue'
import Media from './Media.vue'
import Stepper from './Stepper.vue'
import Publish from './Publish.vue'
import Preview from './Preview.vue'
import Duration from './Duration.vue'
import Overview from './Overview.vue'
import QqQuestion from './QqQuestion.vue'
import CategoriesPicker from './Categories.vue'
import { useChallengeCreationFlow } from '/app/composables/challenge-create-flow'
import { useFormContext } from '/app/composables/form'

const form = useFormContext()

import { inject } from 'vue'
const builder = inject('builder')
const {
    completedCategory, completedImage, completedDuration, completedPrize,
    completedQQQuestion, hasSlug,
} = useChallengeCreationFlow()

const stepper = ref(null)
</script>

<template>
    <stepper ref="stepper">
        <template #left>
            <div class="order-2 lg:order-1 col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3 mt-5 lg:mt-0">
                <div class="challenge-section-heading is-center">
                    <p class="challenge-section-heading__title">
                        <i>Your Question Preview</i>
                    </p>
                    <p class="challenge-section-heading__description"><i>In progress</i></p>
                </div>
                <Preview :challenge="form.fields.challenge" />
            </div>
        </template>
        <step id="category" class="col-span-12" title="Category" :complete="completedCategory" :disabled="hasSlug" hide-actions>
            <CategoriesPicker
                v-model="form.fields.challenge.platform_category"
                v-model:categoryTree="builder.categoryTree"
                @change="stepper.next()"
            />
        </step>
        <step id="question-description" class="col-span-12 order-1 sm:order-2 sm:col-span-7 lg:col-span-8 xl:col-span-9" title="Question &amp; Description" :disabled="hasSlug" :complete="completedQQQuestion" show-left>
            <qq-question></qq-question>
        </step>
        <step id="image" class="col-span-12 order-1 sm:order-2 sm:col-span-7 lg:col-span-8 xl:col-span-9" title="Image" :disabled="hasSlug" :complete="completedImage" show-left>
            <media></media>
        </step>
        <step id="duration" class="col-span-12 order-1 sm:order-2 sm:col-span-7 lg:col-span-8 xl:col-span-9" title="Duration" :disabled="hasSlug" :complete="completedDuration" show-left>
            <duration></duration>
        </step>
        <step id="money-prizes" class="col-span-12 order-1 sm:order-2 sm:col-span-7 lg:col-span-8 xl:col-span-9" title="Money &amp; Prizes" :disabled="hasSlug" :complete="completedPrize" show-left>
            <prize></prize>
        </step>
        <step class="col-span-12" title="Preview, Edit &amp; Publish" :disabled="hasSlug" :complete="hasSlug" activator>
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12 sm:col-span-8">
                    <publish></publish>
                </div>

                <div class="col-span-12 sm:col-span-4">
                    <overview></overview>
                </div>
            </div>
        </step>
        <step class="col-span-12" :disabled="!hasSlug" title="Share" hide-actions>
            <share></share>
        </step>
    </stepper>
</template>
